const CompanyReserve = {
  id: '',
};



export default CompanyReserve;
